import React, { useEffect, useState } from "react";
import axios from 'axios';
import AttivitaChatMessage from "./attivita_chatmessage";
import { getAuth, onAuthStateChanged } from "../../../../../globals/backend/authClient";   
import Dashboard_Loader from "../../navigation/dashboard_loader";
import TicketLoading from "../ticket_loading";

function AttivitaChatBox({ IDAttivita, onInvia, onDelete }) {
    const [messages, setMessages] = useState([]);
    const [userEmail, setUserEmail] = useState("");
    const [showLoader, setShowLoader] = useState(false);


    const auth = getAuth();
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const userEmail = user.email;
                setUserEmail(userEmail);
            }
        });
        return () => unsubscribe();
    }, [auth]);

    const fetchComments = async () => {
        setShowLoader(true);
        try {
            const response = await fetch(`https://scanteq.com/php/comments_attivita.php?IDAttivita=${IDAttivita}`);
            if (!response.ok) {
                throw new Error('Errore nella risposta della rete');
            }
            console.log(response);

            const text = await response.text();
            const data = JSON.parse(text);
            console.log(data);
            setMessages(data);
        } catch (error) {
            console.error("Errore nel caricamento dei messaggi:", error);
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 800);
        }
    };

    useEffect(() => {
        fetchComments();
    }, [IDAttivita]);



    const [nome, setNome] = useState("");
    const [ore, setOre] = useState("");
    const [messaggio, setMessaggio] = useState("");

    const handleSendMessage = async (e) => {
        e.preventDefault();


        if (!nome.trim() || !messaggio.trim() || !ore.trim()) {
            window.alert("Per favore, compila sia il nome che il messaggio che le ore lavorate.");
            return;
        }

        const isConfirmed = window.confirm("Sei sicuro di voler inviare questo commento?");
        if (!isConfirmed) return;

        try {
            const response = await axios.post("https://scanteq.com/php/comments_attivita.php", {
                IDAttivita,
                Nome: nome,
                Messaggio: messaggio,
                Autore: userEmail,
                Ore: ore
            });
            fetchComments()
            onInvia(ore)
            setNome("")
            setMessaggio("")
            setOre("")
        } catch (error) {
            console.error("Errore nell'invio del commento:", error);
        }
    };

    const handleOnDeleteMessage = (ore) => {
        onDelete(ore)
        fetchComments()
    }



    return (
        <>
            <div className="ticket_chatbox_upper_attivita">
                <div className="ticket_chatbox_messages">
                    {Array.isArray(messages) && messages.map((msg, index) => {
                        let decodedMessage;
                        try {
                            decodedMessage = decodeURIComponent(msg.Messaggio);
                        } catch (e) {
                            console.error("Errore nel decodificare il messaggio:", e);
                            decodedMessage = msg.Messaggio; // Usa il messaggio originale in caso di errore
                        }
                        return (
                            <>
                                {showLoader && <TicketLoading />}
                                {!showLoader && <AttivitaChatMessage
                                    key={index}
                                    Name={msg.Nome}
                                    Date={msg.Data}
                                    Hours={msg.Ore}
                                    Message={decodedMessage}
                                    isScanteq={msg.Autore === "admin@auth.com"}
                                    MessageID={msg.ID}
                                    onDeleteMessage={(ore) => handleOnDeleteMessage(ore)}
                                    isAdmin={userEmail === "admin@auth.com"}
                                    canDelete={index !== 0}
                                />}
                            </>
                        );
                    })}
                </div>
                <div className="ticket_chatbox_toolbar">
                    <div className="ticket_message-input">
                        <form>
                            <textarea
                                placeholder="Inserisci il tuo commento qui"
                                className="ticket_message-send"
                                value={messaggio}
                                onChange={(e) => setMessaggio(e.target.value)}
                            />
                            <textarea
                                placeholder="Nome Cognome"
                                className="ticket_message-send-namesurname"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                            />
                            <textarea
                                placeholder="Ore"
                                className="ticket_message-send-namesurname"
                                value={ore}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/\D/g, '');
                                    setOre(numericValue);
                                }}
                            />
                            <button onClick={handleSendMessage} className="ticket_button-send">Invia</button>
                        </form>
                    </div>
                </div>
            </div>
            {false && <Dashboard_Loader />}
        </>
    );
}

export default AttivitaChatBox;
